module.exports = __webpack_public_path__ + "static/media/icon_6.d17bafac.png";